import styled from 'styled-components';

export const AboutContainer = styled.div`
  .inner-hero-content p {
    color: ${({ theme: { colors } }) => colors.darkGrey};
    font-size: 18px;
    letter-spacing: 0.2px;
    margin-bottom: 26px;
    line-height: 28px;
  }
  .inner-hero-content {
    padding-left: 20px;
    margin-left: 50px;
    border-left: 3px solid ${({ theme: { colors } }) => colors.pink};
  }

  .inner-hero-area .scroll-down p {
    color: #000;
  }

  .inner-banner-img img {
    width: 100%;
  }
  .inner-banner-img {
    margin-left: calc((100vw - 1185px) / 2);
    margin-bottom: 68px;
  }
  .inner-txt-block p {
    color: ${({ theme: { colors } }) => colors.darkGrey};
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
    max-width: 530px;
  }
  .inner-tab-area {
    padding: 120px 0 137px;
  }

  .inner-tabs-triggers {
    list-style-type: none;
    justify-content: space-evenly;

    li {
      button {
        opacity: 0.4;
        color: ${({ theme: { colors } }) => colors.darkGrey};
        font-size: 16px;
        letter-spacing: -0.12px;
        line-height: 28px;
        padding: 17px 0;
        display: inline-block;
        position: relative;
        background: unset;
        background-color: unset;
        border: 0;

        &::after {
          position: absolute;
          bottom: 0;
          left: 0;
          height: 2px;
          width: 0;
          transition: 0.3s all;
          content: '';
          background-color: ${({ theme: { colors } }) => colors.pink};
        }
      }
    }

    .active-tab button,
    li button:hover {
      color: ${({ theme: { colors } }) => colors.darkGrey};
      opacity: 1;
      font-weight: bold;

      &::after {
        width: 100%;
      }
    }
  }

  .inner-tab-brdr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .tab-content h3 {
    color: #000000;
    font-family: Vollkorn, sans-serif;
    font-size: 44px;
    font-weight: bold;
    letter-spacing: -0.36px;
    line-height: 1.1875;
  }
  .tab-content p {
    color: ${({ theme: { colors } }) => colors.darkGrey};
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }

  .inner-tab-content-area {
    margin-top: 79px;
    min-height: 529px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .tab-inner-img {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 49%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  .founder-txt h5 {
    font-family: Vollkorn, sans-serif;
    font-size: 30px;
    font-weight: bold;
    line-height: 43px;
    margin-bottom: 35px;
  }
  .founder-speak {
    position: relative;
    background-color: #0d0d16;
    padding: 120px 0 88px;

    * {
      color: #fff;
    }
  }
  .founder-txt img {
    width: 60px;
    border-radius: 50%;
    margin-right: 20px;
    vertical-align: middle;
  }
  .founder-txt--about {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 15px;
  }

  .principles-section {
    &::after,
    &::before {
      background-position: center top !important;
    }
  }

  .project-steps-main {
    padding: 103px 0 0;
  }
  .principle-main {
    padding: 180px 0 0;
  }

  .principles-row {
    padding-top: 30px;
    padding-bottom: 50px;

    * {
      color: #ffffff;
    }

    h3 {
      font-size: 32px;
      letter-spacing: -0.24px;
      margin: 0;

      @media only screen and (max-width: 767px) {
        font-size: 22px;
      }
    }

    p {
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 30px;
      max-width: 240px;
    }

    & > div {
      padding-top: 25px;
      padding-bottom: 25px;
    }
  }

  .abt-second::before {
    opacity: 0.03;
    background-color: #fafafa;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 39%;
    content: '';
  }
  .abt-second {
    padding: 180px 0 90px;
    padding: 180px 0;
    position: relative;
  }
  .abt-second-desc p {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }
  .abt-second-desc {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .abt-second-desc .read-more-btn {
    color: #fff;
    margin-top: auto;
    max-width: 150px;
    text-align: center;
  }
  .abt-third {
    position: relative;

    &--img {
      left: 0;
      top: 0;
      bottom: 0;
      width: 43%;

      @media only screen and (max-width: 767px) {
        width: 100%;
        top: 250px;
      }
    }
  }
  .abt-third-desc {
    min-height: 815px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .founder-img {
    background-position: center right;
    position: absolute;
    top: 10%;
    right: 0;
    width: 40%;
    height: 80%;
    background-repeat: no-repeat;
  }

  .join-us-main {
    background-color: ${({ theme: { colors } }) => colors.darkGrey};
    padding: 60px;
    margin: 70px 0 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .join-us-main h2 {
    width: 75%;
  }

  .project-slide-control {
    left: 0px;
  }

  .pink-rotate-txt p {
    color: ${({ theme: { colors } }) => colors.pink};
    font-family: 'Be Vietnam Pro';
    font-weight: 600;
  }

  .rotated-tab-txt.pink-rotate-txt p::after {
    height: 2px;
    right: -30px;
    background-color: ${({ theme: { colors } }) => colors.pink};
  }

  .abt-second .rotated-tab-txt {
    top: 44%;
    left: -330px;
  }

  @media (max-width: 1024px) {
    .tab-content h3 {
      color: #000000;
      font-family: Vollkorn, sans-serif;
      font-size: 34px;
      font-weight: bold;
      letter-spacing: -0.36px;
      line-height: 42px;
    }
    .founder-img {
      width: 44%;
      height: 90%;
    }
    .medium-heading {
      font-size: 36px;
      line-height: 45px;
    }
    .principle-main {
      padding: 80px 0 0;
    }
  }

  @media (max-width: 767px) {
    .inner-hero-content {
      margin-left: 0;
      border-left: none;
      padding: 0;
    }

    .inner-banner-img {
      width: 100%;
      margin: 0;
      margin-bottom: 38px;
    }
    .inner-tab-area {
      padding: 30px 0 37px;
    }
    .inner-tab-content-area {
      display: block;
      margin-top: 50px;
      min-height: 10px;

      .container {
        padding-top: 270px;
      }
    }
    .inner-tabs-triggers {
      justify-content: space-between;
    }
    .tab-inner-img {
      position: static;
      height: 240px;
      width: 96%;
      margin-left: auto;
    }

    .founder-speak {
      padding: 60px 0;
      overflow: hidden;
    }
    .founder-txt h5 {
      font-size: 22px;
      line-height: 31px;
    }

    .founder-img {
      width: 100%;
      height: 100%;
      background-size: 95%;
      bottom: -15%;
      top: auto;
    }

    .project-stp-content {
      flex-direction: column;
    }
    .abt-second {
      padding: 50px 0 90px;
    }

    .abt-second-desc {
      padding-top: 35px;
    }
    .abt-second::before {
      opacity: 0.025;
      top: auto;
      width: 49%;
      height: 60%;
    }

    .abt-third {
      padding-top: 45px;
      position: relative;
      padding-bottom: 345px;
    }
    .abt-third::after {
      top: auto;
      width: 100%;
      height: 320px;
    }
    .abt-third-desc {
      min-height: 10px;
    }

    .medium-heading {
      font-size: 22px;
      line-height: 31px;
    }
    .abt-third-desc h2 {
      text-align: center;
    }
    .abt-third-desc p {
      text-align: center;
    }
    .join-us-main h2 {
      width: 100%;
      text-align: center;
    }
    .join-us-main .pink-btn-big {
      display: block;
      margin-top: 25px;
    }
    .join-us-main {
      padding: 30px;
      margin: 70px 0 50px;
      display: block;
    }
  }
`;
